export const FIELD_LABELS = {
  hierarchyId: 'Hierarchy',
  displayShipper: 'Store Display / Shipper',
  unitUpc: 'Unit UPC12',
  multipack: 'Multipack',
  vendorItemNumber: 'Vendor Item # / SKU',
  brandName: 'Brand Name',
  productName: 'Product Name',
  productDescription: 'Product Description',
  ecommerceDescription: 'eCom Description',
  size: 'Primary Size',
  sizeUom: 'Primary Size UoM',
  merchandisedInTray: 'Merchandised In Tray?',
  perishable: 'Perishable',
  foodServiceBulkItems: 'Foodservice or Bulk Pack',
  variableWeight: 'Variable Weight / Catch Weight',
  innerPackUpc: 'Innerpack UPC',
  innerPackGtin: 'Innerpack GTIN',
  innerPackSellable: 'Innerpack Retailer Sellable?',
  innerPackPackSize: 'Innerpack Pack Size',
  noCodeCase: 'No Case Code',
  caseUpc12: 'Case UPC-12',
  caseGtin: 'Case GTIN',
  caseSellable: 'Is Case Sellable?',
  caseInnerPackCount: 'Case Innerpack Count',
  casePackSize: 'Case Pack Size',
};
